module.exports = __webpack_public_path__ + "img/file-waveform.e00c58df.svg";